import { IQuoteState } from '@/store/quote/quote.state';
import {
    IAddress,
    IClientDataEntity,
    IClientEntity,
    IDocumentEntity,
    IQuoteEntity,
    IUpsertQuoteBody,
    IUserEntity,
} from '@phrospr/api-backend';

export const quoteMutations = {
    setQuoteAttachments(state: IQuoteState, attachments: IDocumentEntity[]) {
        state.attachments = attachments;
        state.attachmentLastSync = new Date();
    },
    setAttachmentBudget(state: IQuoteState, attachmentBudgetBytes: number | null) {
        state.attachmentBudgetBytes = attachmentBudgetBytes;
    },
    setQuoteUsers(state: IQuoteState, users: IUserEntity[]) {
        state.quoteUsers = users;
        state.quoteUsersLastSync = new Date();
    },
    resetQuoteV2(state: IQuoteState) {
        state.upsertQuote = undefined;
    },
    createNewQuoteV2: function (state: IQuoteState) {
        state.upsertQuote = {
            upsertQuote: {
                data: {
                    created_by_user_id: null,
                    sold_by_user_id: null,
                    technicalFiche: undefined,
                    btw_percentage: 0.06,
                    delivery_address: null,
                },
                document_ids: [],
                quoteLines: [],
                placementCost: 0,
                sendEmailToCustomer: true,
            },
        };
    },

    updateQuoteV2(state: IQuoteState, quote: IQuoteEntity) {
        state.upsertQuote = {
            upsertQuote: {
                quoteLines: quote.quote_lines,
                quoteId: quote.quote_id,
                placementCost: quote.placement_cost,
                sold: quote.sold,
                data: quote.data,
                document_ids: (quote.documents ?? []).map(document => document.document_id),
                sendEmailToCustomer: false,
            },
            client_id: quote.client_id,
            lead_planning_id: quote.planning_item_lead?.planning_item_id,
        };
    },
    cacheQuoteV2(state: IQuoteState, quoteUpsert: IUpsertQuoteBody) {
        state.upsertQuote = quoteUpsert;
    },
    quoteV2AddClient(state: IQuoteState, clientData: IClientDataEntity) {
        state.upsertQuote.newClient = clientData;
    },
    setRestoreCacheV2(state: IQuoteState) {
        state.isCachedUpsertQuote = true;
    },
    removeCacheQuoteV2(state: IQuoteState) {
        state.isCachedUpsertQuote = undefined;
    },
    setSelectedClientQuote(state: IQuoteState, selectedClient: IClientEntity) {
        state.selectedClient = selectedClient;
    },

    setSelectedAddressClient(state: IQuoteState, selectedAddress: IAddress) {
        state.upsertQuote.upsertQuote.data.delivery_address = selectedAddress;
    },
};
